export const formatAsHierarchyOptions = hierarchies => hierarchies.reduce((acc, item) => {
    acc.push({
      label: item.name,
      side: 1,
      value: item.level,
    })
    return acc
  }, [])
